/**
 * Popup para atribuir o pending order à rota.
 * @author: adalto.junior
 * Date: 23/12/13
 * Time: 13:35
 */


Greenmile.RouteSuggestion = Greenmile.RouteSuggestion || {};

Greenmile.RouteSuggestion.PopupAssignToRoute = (function () {

    function PopupAssignToRoute () {

        Monet.GenericModal.apply(this, arguments);

        var __route;
        var __pendingOrder;
        var __stopTypes;
        var __stopTypeId;

        var __relatedStop = {
            id: null
        };
        var __placement;
        var __stopType;

        this.setStopTypeId = function (stopTypeId) {
            __stopTypeId = stopTypeId;
        };

        this.getStopTypeId = function () {
            return __stopTypeId;
        };

        this.setRoute = function (route) {
            __route = route;
        };

        this.getRouteId = function () {
            return __route.route;
        };

        this.getRoute = function () {
            return __route;
        };

        this.setPendingOrder = function (pendingOrder) {
            __pendingOrder = pendingOrder;
        };

        this.getPendingOrder = function () {
            return __pendingOrder;
        };

        this.setPlacement = function (placement) {
            __placement = placement;
        };

        this.getPlacement = function () {
            return __placement;
        };

        this.setRelatedStopId = function (stopId) {
            __relatedStop.id = stopId;
        };

        this.geRelatedStop = function () {
            return __relatedStop;
        };

        this.setStopTypes = function (stopTypes) {
            __stopTypes = stopTypes;
        };

        this.getStopTypes = function () {
            return __stopTypes;
        };
        const showErrorMessage = (response) => {
          const monetMessage = new Monet.Form.Messages.InlineMessage();

          monetMessage.setScope("#RouteSuggestion .popupFormContainer");
          monetMessage.setInfoType("error");
          monetMessage.setMessage(response);
          monetMessage.triggerMessage();
        };

        this.hideLoadingAndShowErrorMessage = (error) => {
          this.modalForm.toggleLoadingInModalBtn(".sectionButtons");
          showErrorMessage(error);
        };

        const hideMessageAndShowLoading = () => {
          const popup =  document.querySelector(`${this.obj.selector}`);
          const alertContainer = popup.querySelector('.monetInlineAlerContainer');
          
          this.modalForm.toggleLoadingInModalBtn(".sectionButtons");

          if (alertContainer.innerHTML) {
            alertContainer.innerHTML = '';
          }
        };

        const assignToRoute = (data) => {
            const callbackSuccess = () => { 
                const popup = document.querySelector(this.obj.selector + ' .popupFormContainer');
                
                if (popup) {
                    const resourceKey = 'Greenmile.RouteSuggestion.Popup.SuccessPopupTitle';
                    const titleSection = createTitleSection(resourceKey);

                    const containerSection = document.createElement('div');
                    containerSection.id = 'RouteSuggestionModalSuccessMessage'

                    const successMessageContainer = document.createElement('p');

                    const buttonClose = new Monet.UI.Fields.Render({
                        type: 'BUTTON',
                        name: 'assignToRouteSuggested',
                        label: 'default.button.close',
                        customJavaScript: assignPendingOrderSuccess
                    });

                    const translatedTitle = Monet.I18n.getResourcesByKey('Greenmile.RouteSuggestion.Popup.SuccessTitle');
                    
                    successMessageContainer.innerHTML = translatedTitle;
                    containerSection.appendChild(successMessageContainer);
                    containerSection.appendChild(sectionButtons(buttonClose, true));
                    
                    popup.innerHTML = "";
                    popup.appendChild(titleSection);
                    popup.appendChild(containerSection);

                    this.addCloseModalCallback();
                }
            };

            const callbackError = (response) => {
                this.hideLoadingAndShowErrorMessage(response);
            };

            hideMessageAndShowLoading();

            new App.Routers.PendingOrdersNotification()
                .assignToRoute(this.getRouteId(), data, { callbackSuccess, callbackError });
        };

        const assignPendingOrderSuccess = () => {
            const isPendingOrderOpen = GreenmileReduxStore.getState().tabs.hasIn(['list', 'PendingOrder']);

            if (isPendingOrderOpen) {
                App.Objects.PendingOrder.list();
                GreenmileReduxStore.dispatch({
                    type: 'GREENMILE_TAB_SELECT',
                    payload: Immutable.fromJS({
                        key: 'PendingOrder'
                    })
                });
            }

            GreenmileReduxStore.dispatch({
                type: 'GREENMILE_TAB_CLOSE',
                payload: Immutable.fromJS({
                    key: 'RouteSuggestion'
                })
            });

            GreenmileReduxStore.dispatch({
                type: 'GREENMILE_ROUTEMONITOR_UPDATE_PENDING_ORDERS_ROW'
            });
        };

        this.getDataAndAssignToRoute = function () {

            var data = {};
            var stopTypeId = __stopTypeId;
            var stopTypeFieldValue = (__stopType ? __stopType.getValue() : null);

            var stId = stopTypeFieldValue || (stopTypeId && typeof stopTypeId === "number" ? { id: stopTypeId } : null);

            if (stId) {

                data['stopTypePendingOrder'] = stId;

                if (__pendingOrder.id) {
                    data['pendingOrder'] = __pendingOrder;
                }

                if (__placement) {
                    data['placement'] = __placement;
                }

                if (__relatedStop) {
                    data['relatedStop'] = __relatedStop;
                }

                assignToRoute(data);

            } else {

                var monetMessage = new Monet.Form.Messages.InlineMessage();
                var response = {
                    errorMessages: [
                      Monet.Form.Messages.mountErrorMessageObject('Greenmile.PendingOrdersNotification.errorStopType')]
                };

                monetMessage.setScope("#RouteSuggestion .popupFormContainer");
                monetMessage.setInfoType("error");
                monetMessage.setMessage(response);
                monetMessage.triggerMessage();

            }

        };

        var sectionStopType = function () {

            const stopTypeField = new Monet.UI.Fields.PowerLookup();

            const labelKey = Monet.I18n.getResourcesByKey('Greenmile.RouteSuggestion.label.stopType');

            stopTypeField.setId('lookupStopType');
            stopTypeField.setNameSpace('PopupAssignToRoute');
            stopTypeField.setDisplayKey('description');
            stopTypeField.setLookUpEntity('StopType');
            stopTypeField.setTextLabel(labelKey);

            stopTypeField.setRequestBody({
                criteriaChain: [
                    {
                        and: [
                            { attr: "type", eq: "STOP" }
                        ]
                    }
                ]
            });

            stopTypeField.render();

            __stopType = stopTypeField;

            return stopTypeField.rootEl;

        };

        var sectionButtons = function (context) {

            return function (mainButton, showOnlyMainButton) {

                var section = document.createElement('div');
                section.className = 'sectionButtons';

                
                if(showOnlyMainButton) {
                    section.appendChild(mainButton.render().rootEl);
                    
                    return section;
                }

                var buttonCancel;
                
                buttonCancel = new Monet.UI.Fields.Render({
                    type: 'BUTTON',
                    name: 'closeWindowPopup',
                    label: 'ConfirmModal.CancelButton',
                    customJavaScript: context.closeModalWindow
                });
                
                const inputbuttonCancel =  buttonCancel.render().rootEl;
                inputbuttonCancel.setAttribute("name", "closeWindowPopup_exit");
                section.appendChild(mainButton.render().rootEl);
                section.appendChild(inputbuttonCancel);

                return section;

            };

        }(this);

        var createTitleSection = function (resource) {
            const section = document.createElement('div');
            section.setAttribute('id', 'routeSuggestionModalTitle');
            
            const title = document.createElement('span');
            const translatedTitle = Monet.I18n.getResourcesByKey(resource);

            title.innerHTML = translatedTitle;

            section.appendChild(title);

            return section;
        }


        this.makeAction = function (scope) {
            return function () {
                var stopTypes = scope.getStopTypes();

                if (stopTypes.length === 1) {
                    scope.setStopTypeId(stopTypes[0].id);
                    scope.renderConfirmMessage();
                } else {
                    scope.renderFormToAssignToRoute();
                }
            };
        }(this);

        this.addCloseModalCallback = function () {
            const closeButtonXElement = document.querySelector('#RouteSuggestion .closeModalWindow');

            closeButtonXElement && 
                closeButtonXElement.removeEventListener('click', assignPendingOrderSuccess);
            closeButtonXElement && 
                closeButtonXElement.addEventListener('click', assignPendingOrderSuccess);
        };

        this.render = function (context) {
            context.modalForm = new Monet.Form.Modal(
                '#RouteSuggestion', 
                null, 
                null, 
                '.gmTabs__panel.is-active'
            );

            return function () {

                var divError = document.createElement('div');
                var form = document.createElement('form');

                divError.className += 'monetInlineAlerContainer';
                var buttonFilter = new Monet.UI.Fields.Render({
                    type: 'BUTTON',
                    name: 'assignToRouteSuggested',
                    label: 'Greenmile.RouteSuggestion.button.assignToRoute',
                    customJavaScript: context.renderConfirmMessage
                });

                form.id = 'RouteSuggestionAssignToRoute';
                form.appendChild(divError);
                form.appendChild(sectionStopType());
                form.appendChild(sectionButtons(buttonFilter, false));

                return form;

            };
        }(this);

        this.renderConfirmMessage = (function (context) {
            return function () {

                var stopTypeFieldValue = (__stopType ? __stopType.getValue() : null);
                var stopTypeId = stopTypeFieldValue || __stopTypeId;

                var popup = document.querySelector(context.obj.selector + ' .popupFormContainer');
                var form = document.createElement('form');

                if (popup) {
                    if (!stopTypeId) {

                        var monetMessage = new Monet.Form.Messages.InlineMessage();
                        var response = {
                            errorMessages: [
                                Monet.Form.Messages.mountErrorMessageObject('Greenmile.PendingOrdersNotification.errorStopType')
                            ]
                        };

                        monetMessage.setScope("#RouteSuggestion .popupFormContainer");
                        monetMessage.setInfoType("error");
                        monetMessage.setMessage(response);
                        monetMessage.triggerMessage();

                    } else {
                        context.getDataAndAssignToRoute();
                    }
                }

            };
        })(this);

        this.getStopTypeList = function () {
            var ajax = new Monet.Ajax();
            ajax.url = 'StopType/restrictions?criteria={"firstResult":0,"maxResults":10}';
            ajax.method = 'POST';
            ajax.data = {
                criteriaChain: [
                    {
                        and: [
                            { attr: "type", eq: "STOP" }
                        ]
                    }
                ]
            };

            ajax.success = (function (scope) {
                return function (data) {
                    if (data) {
                        scope.setStopTypes(data);
                        scope.makeAction();
                    }
                };
            })(this);

            ajax.error = (function (escopo) {
                return function (responseText) {

                    if (responseText.status === 401) {
                        window.location = '#/AccessDenied/401';
                    } else {
                        var popup = document.querySelector(escopo.obj.selector + ' .popupFormContainer');
                        var divError = document.querySelector(escopo.obj.selector + ' .popupFormContainer .monetInlineAlerContainer');
                        if (popup) {
                            var form = document.createElement('form');
                            if (!divError) {
                                divError = document.createElement('div');
                                divError.className += 'monetInlineAlerContainer';
                                form.appendChild(divError);
                                popup.appendChild(form);
                            }

                            var list = document.createElement('ul');
                            list.className = 'alert alert-error';
                            list.style.display = 'block';

                            var item = document.createElement('li');
                            item.innerHTML = responseText.statusText;
                            list.appendChild(item);
                            divError.appendChild(list);
                        }

                    }
                    console.log('[ERROR][' + new Date() + '] Error trying list StopTypes. ');
                    console.log(responseText);
                };
            }(this));

            ajax.send();
        };

        this.renderFormToAssignToRoute = function () {

            var popup;
            var error;

            try {

                popup = document.querySelector(this.obj.selector + ' .popupFormContainer');
                
                if (popup) {
                    const resourceKey = 'Greenmile.RouteSuggestion.PopupAssignToRoute.Title';
                    const titleSection = createTitleSection(resourceKey);

                    popup.innerHTML = "";
                    popup.appendChild(titleSection);
                    popup.appendChild(this.render());
                }

            } catch (e) {

                error = new Monet.Exception.ReturnError(
                    this, 'Error on render form to assign to route', e);
                error.console();

            }

        };

        this.createAllStructure = function (context) {

            return function () {
                context.getStopTypeList();

            };

        }(this);


    }

    return PopupAssignToRoute;

}());
